export const RunnerConfigurationKeys = {
    AWSInstanceType: "instanceType",
    DiskSizeGB: "diskSizeGB",
    CPU: "cpu",
    Memory: "memory",
    SpotInstanceEnabled: "spot",
};

export const AWSRunnerAdditionalFieldsKeys = {
    AWSAccountID: "awsAccountID",
    StackURL: "awsCloudFormationStackURL",
    StackName: "awsCloudFormationStackName",
    Region: "region",
    LogURL: "logURL",
};

export const LinuxRunnerAdditionalFieldsKeys = {
    OS: "os",
    RootDiskSize: "rootDiskSize",
    HomeDiskSize: "homeDiskSize",
    Kernel: "kernel",
    Cores: "cores",
    Memory: "memory",
    Hostname: "hostname",
};
